// [ICON_LIST_START]
const iconsList = {
    play: "play",
    registration: "registration",
    advanced: "advanced",
    competition: "competition",
    finalEvent: "finalEvent",
    finalists: "finalists",
    training: "training",
    arrows: "arrows",
    key: "key",
    victoryCup: "victoryCup",
    finalVictoryCup: "finalVictoryCup",
    task: "task",
    close: "close",
    export: "export",
    star: "star",
    qualifyingB: "qualifyingB",
    check: "check",
    people: "people",
    silverMedal: "silverMedal",
    medal: "medal",
    desktop: "desktop",
    virtualSchool: "virtualSchool",
    goldMedal: "goldMedal",
    countersStar: "countersStar",
    right: "right",
    left: "left",
    checkmarkGreen: "checkmarkGreen",
    down: "down",
    download: "download",
    calendar: "calendar",
    clock: "clock",
    camera: "camera",
    finalParticipants: "finalParticipants",
    finalStages: "finalStages",
    finalMinutes: "finalMinutes",
    backArrow: "backArrow",
    threeDots: "threeDots",
    zoom: "zoom",
    finalBoysGirls: "finalBoysGirls",
    events: "events",
    everyone: "everyone"
}
// [ICON_LIST_END]
export default iconsList
